export const SAND_TYPES = {
  GREY: 'Standard Grey',
  COLOUR: 'Black Colour',
  BLOCKFILL: 'BlockFill',
  STABILISED_SAND: 'Stabilised Sand',
  EXPOSED: 'Exposed'
} as const;

export const PRODUCTIDS = {
  PUMP: '8b75da2b-dc9d-491c-ba39-64983a5b2733',
  MINI: '5ecd2132-f4e3-4491-aaa9-2d4fc1683a8f',
  MAXI: '16046b25-b94f-45a6-a4e7-76dbc1150cd4',
  STEEL: 'e9de017a-2c22-4ca1-8fba-e49f76e1381d'
} as const;
